import { post, postJson, get, deleteApi, put } from './axios3'
export const fullGiftSave = (p) => postJson(`/fullGift/save`, p);
// 满赠有礼活动详情
export const fullGiftDetail = (p) => get(`/fullGift/detail/${p}`);